import {createSlice} from "@reduxjs/toolkit";

export const stateSlice = createSlice({
  name: "compatibility-long",
  initialState: {
    name: null,
    birthDate: {},
    birthPlace: "",
    birthTime: {},
    gender: "",
    partnerName: "",
    partnerBirthDate: {},
    partnerBirthPlace: "",
    partnerBirthTime: {},
    relationshipStatus: "",
    communicationStyle: "",
    personalSpace: "",
    spendWeekends: "",
    ambitions: "",
    friends: "",
    howHappy: null,
    newThings: "",
    spendingTime: "",
  },
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setBirthDate: (state, action) => {
      state.birthDate = action.payload;
    },
    setBirthPlace: (state, action) => {
      state.birthPlace = action.payload;
    },
    setBirthTime: (state, action) => {
      state.birthTime = action.payload;
    },
    setGender: (state, action) => {
      state.gender = action.payload;
    },
    setPartnerName: (state, action) => {
      state.partnerName = action.payload;
    },
    setPartnerBirthDate: (state, action) => {
      state.partnerBirthDate = action.payload;
    },
    setPartnerBirthPlace: (state, action) => {
      state.partnerBirthPlace = action.payload;
    },
    setPartnerBirthTime: (state, action) => {
      state.partnerBirthTime = action.payload;
    },
    setRelationshipStatus: (state, action) => {
      state.relationshipStatus = action.payload;
    },
    setCommunicationsStyle: (state, action) => {
      state.communicationStyle = action.payload;
    },
    setPersonalSpace: (state, action) => {
      state.personalSpace = action.payload;
    },
    setSpendWeekends: (state, action) => {
      state.spendWeekends = action.payload;
    },
    setAmbitions: (state, action) => {
      state.ambitions = action.payload;
    },
    setFriends: (state, action) => {
      state.friends = action.payload;
    },
    setHowHappy: (state, action) => {
      state.howHappy = action.payload;
    },
    setNewThings: (state, action) => {
      state.newThings = action.payload;
    },
    setSpendingTime: (state, action) => {
      state.spendingTime = action.payload;
    },
  },
});

export const {
  setName,
  setBirthDate,
  setBirthPlace,
  setBirthTime,
  setGender,
  setPartnerName,
  setPartnerBirthDate,
  setPartnerBirthPlace,
  setPartnerBirthTime,
  setRelationshipStatus,
  setCommunicationsStyle,
  setPersonalSpace,
  setSpendWeekends,
  setAmbitions,
  setFriends,
  setHowHappy,
  setNewThings,
  setSpendingTime
} = stateSlice.actions;

export default stateSlice.reducer;
